module.exports = __webpack_public_path__ + "static/media/canteen.0a40e6b0.svg";